<div class="">
  <!-- View Link Button with Popover -->
  <button
    class="btn btn-shadow btn-h42"
    role="button"
    [ngbPopover]="viewLink"
    [autoClose]="'outside'"
    placement="bottom-right top-right"
    triggers="click"
    (shown)="ensureLinkGenerated()"
  >
    <i class="bi bi-link-45deg"></i>
    @if (showText()) {
      View Link
    }
  </button>

  <!-- Link Popover Template -->
  <ng-template #viewLink>
    <div>
      <div class="d-flex align-items-center gap-3 px-3 py-2 rounded-5 alert alert-info mb-0">
        <span class="text-truncate">{{ generatedShareLink() || 'Generating Link...' }}</span>
        <button
          class="btn btn-info btn-h35 text-nowrap"
          (click)="copyToClipboard(generatedShareLink()!)"
          [disabled]="!generatedShareLink()"
        >
          Copy
        </button>
      </div>

      <!-- Link Restrictions Section -->
      @if (showRestrictions() && currentLink()) {
        <div class="mt-3">
          <h6 class="fw-500">Link Restrictions</h6>
          <p class="mb-2 small">Prevent non-members from accessing this item via link.</p>
          <div class="form-check form-switch form-switch-lg">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="linkRestriction-{{ uid }}"
              [checked]="!currentLink()?.isActive"
              [disabled]="isTogglingRestriction()"
              (click)="toggleLinkRestriction()"
            />
            <label class="form-check-label" for="linkRestriction-{{ uid }}"></label>
          </div>
        </div>
      }
    </div>
  </ng-template>
</div>
